import axios from 'axios';
import {useQuery, useQueryClient} from '@tanstack/react-query';

import {UserIdentity} from '../../../typings/user';

function getCurrentUserRequest() {
    return axios.get<UserIdentity>('/users-service/api/users/self').then((res) => res.data);
}

/** Returns user info */
export function useCurrentUserQuery(enabled?: boolean) {
    return useQuery<UserIdentity>({
        queryKey: ['getCurrentUserRequest'],
        queryFn: getCurrentUserRequest,
        enabled
    });
}

/** User info query cache manager */
export function useCurrentUserQueryCache() {
    const queryClient = useQueryClient();

    function updateCurrentUser(userData: Partial<UserIdentity>) {
        queryClient.setQueriesData<UserIdentity | undefined>(
            {queryKey: ['getCurrentUserRequest']},
            (currentState) =>
                currentState && {
                    ...currentState,
                    ...userData
                }
        );
    }

    return {updateCurrentUser};
}
